// components/FormControllers/CompanyDirectorDetailsController.js

import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import CompanyDirectorSelect from '../FormInputs/CompanyDirectorSelect';

const CompanyDirectorSelectController = ({
  name,
  label,
  company_number,
  register,
  errors,
  sx,
  helptext,
}) => {
  const { control } = useFormContext();

  //const companyNumber = watch(company_number);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={''}
      render={({ field }) => (
        <CompanyDirectorSelect
          {...field}
          label={label}
          company_number={company_number}
          register
          errors
          sx = {field.sx || sx}
          helptext={helptext}
        />
      )}
    />
  );
};

export default CompanyDirectorSelectController;
